import { Dispatch, SetStateAction } from 'react'

import { FirebaseError } from 'firebase/app'
import {
  deleteObject,
  getDownloadURL,
  listAll,
  ListResult,
  ref,
  StorageReference,
} from 'firebase/storage'

import { handleErrors } from '../../utilFunctions/firebaseErrors'
import { storage } from '../firebaseConfig'

export const listAllStorage = async (folderRef: StorageReference) => {
  listAll(folderRef)
    .then((res) => {
      const files = res.items
      const promises = files.map((itemRef) => {
        // Obtén el enlace de descarga de cada archivo
        return getDownloadURL(itemRef).then((downloadURL) => {
          return {
            name: itemRef.name,
            downloadLink: downloadURL,
          }
        })
      })
      return Promise.all(promises)
    })
    .then((results) => {
      return results
    })
    .catch((error) => {
      return error
    })
}

export const getFileByCategory = async (files: ListResult) => {
  const filesByType: Record<string, { title: string; url: string }[]> = {}

  for (const folder of files.prefixes) {
    const gender = folder.name
    const folderFiles = await listAll(folder)

    const mapped = await Promise.all(
      folderFiles.items.map(async (file) => ({
        title: file.name,
        url: await getDownloadURL(file),
      })),
    )

    filesByType[gender] = mapped
  }

  return filesByType
}

// NO SE USA
export const downloadFile = async (
  fileName: string,
  userId: string,
  setError?: Dispatch<SetStateAction<string | null>>,
) => {
  try {
    const fileRef = ref(storage, `${userId}/${fileName}`)

    const downloadUrl = await getDownloadURL(fileRef)
    return downloadUrl
    // TODO: replace lines 114 and 115 with
    // const url = await guardedCall(() => getDownloadURL(fileRef))
    // return url
  } catch (error) {
    console.error('Error al descargar el archivo:', error)
    setError && `Error al descargar el archivo: ${error}`
  }
}

export const removeFile = async (
  refId: string,
  setError?: Dispatch<SetStateAction<string | null>>,
) => {
  try {
    const imgRef = ref(storage, refId)
    await deleteObject(imgRef)
  } catch (error) {
    const { code, message } = error as FirebaseError
    const friendly = handleErrors(code)
    console.error('Error al eliminar el archivo:', error)
    setError && setError(friendly || message)
  }
}
